export default "__VITE_ASSET__BD9CK7Dl__"